// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__vnkji","hamburger":"Header_hamburger__0Oz-R"};